import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../core/has.js";
import { isSome as t, isNone as o } from "../../core/maybe.js";
import { webglValidateShadersEnabled as i } from "./checkWebGLError.js";
import { ResourceType as r } from "./enums.js";
import { transpileShader as e } from "./ShaderTranspiler.js";

var n = /*#__PURE__*/function () {
  function n(t, o, i, e) {
    _classCallCheck(this, n);

    this._context = t, this._locations = e, this._nameToUniformLocation = {}, this._nameToUniform1 = {}, this._nameToUniform1v = {}, this._nameToUniform2 = {}, this._nameToUniform3 = {}, this._nameToUniform4 = {}, this._nameToUniformMatrix3 = {}, this._nameToUniformMatrix4 = {}, t || console.error("RenderingContext isn't initialized!"), 0 === o.length && console.error("Shaders source should not be empty!"), this._vShader = m(this._context, 35633, o), this._fShader = m(this._context, 35632, i), this._vShader && this._fShader || console.error("Error loading shaders!"), this._context.instanceCounter.increment(r.VertexShader, this), this._context.instanceCounter.increment(r.FragmentShader, this);
  }

  _createClass(n, [{
    key: "glName",
    get: function get() {
      if (t(this._glName)) return this._glName;
      if (o(this._vShader)) return null;

      var e = this._context.gl,
          _n = e.createProgram();

      return e.attachShader(_n, this._vShader), e.attachShader(_n, this._fShader), this._locations.forEach(function (t, o) {
        return e.bindAttribLocation(_n, t, o);
      }), e.linkProgram(_n), i() && !e.getProgramParameter(_n, e.LINK_STATUS) && console.error("Could not link shader\nvalidated: ".concat(e.getProgramParameter(_n, e.VALIDATE_STATUS), ", gl error ").concat(e.getError(), ", vertex: ").concat(e.getShaderParameter(this._vShader, e.COMPILE_STATUS), ", fragment: ").concat(e.getShaderParameter(this._fShader, e.COMPILE_STATUS), ", info log: ").concat(e.getProgramInfoLog(_n))), this._glName = _n, this._context.instanceCounter.increment(r.Program, this), _n;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var t = this._context.gl;
      this._vShader && (t.deleteShader(this._vShader), this._vShader = null, this._context.instanceCounter.decrement(r.VertexShader, this)), this._fShader && (t.deleteShader(this._fShader), this._fShader = null, this._context.instanceCounter.decrement(r.FragmentShader, this)), this._glName && (t.deleteProgram(this._glName), this._glName = null, this._context.instanceCounter.decrement(r.Program, this));
    }
  }, {
    key: "_getUniformLocation",
    value: function _getUniformLocation(t) {
      return void 0 === this._nameToUniformLocation[t] && (this._nameToUniformLocation[t] = this._context.gl.getUniformLocation(this.glName, t)), this._nameToUniformLocation[t];
    }
  }, {
    key: "hasUniform",
    value: function hasUniform(t) {
      return null !== this._getUniformLocation(t);
    }
  }, {
    key: "setUniform1i",
    value: function setUniform1i(t, o) {
      var i = this._nameToUniform1[t];

      if (void 0 === i || o !== i) {
        this._context.useProgram(this);

        this._context.gl.uniform1i(this._getUniformLocation(t), o), this._nameToUniform1[t] = o;
      }
    }
  }, {
    key: "setUniform1iv",
    value: function setUniform1iv(t, o) {
      var i = this._nameToUniform1v[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform1iv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform1v[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform2iv",
    value: function setUniform2iv(t, o) {
      var i = this._nameToUniform2[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform2iv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform2[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform3iv",
    value: function setUniform3iv(t, o) {
      var i = this._nameToUniform3[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform3iv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform3[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform4iv",
    value: function setUniform4iv(t, o) {
      var i = this._nameToUniform4[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform4iv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform4[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform1f",
    value: function setUniform1f(t, o) {
      var i = this._nameToUniform1[t];

      if (void 0 === i || o !== i) {
        this._context.useProgram(this);

        this._context.gl.uniform1f(this._getUniformLocation(t), o), this._nameToUniform1[t] = o;
      }
    }
  }, {
    key: "setUniform1fv",
    value: function setUniform1fv(t, o) {
      var i = this._nameToUniform1v[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform1fv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform1v[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform2f",
    value: function setUniform2f(t, o, i) {
      var r = this._nameToUniform2[t];

      if (void 0 === r || o !== r[0] || i !== r[1]) {
        this._context.useProgram(this);

        this._context.gl.uniform2f(this._getUniformLocation(t), o, i), void 0 === r ? this._nameToUniform2[t] = [o, i] : (r[0] = o, r[1] = i);
      }
    }
  }, {
    key: "setUniform2fv",
    value: function setUniform2fv(t, o) {
      var i = this._nameToUniform2[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform2fv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform2[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform3f",
    value: function setUniform3f(t, o, i, r) {
      var e = this._nameToUniform3[t];

      if (void 0 === e || o !== e[0] || i !== e[1] || r !== e[2]) {
        this._context.useProgram(this);

        this._context.gl.uniform3f(this._getUniformLocation(t), o, i, r), void 0 === e ? this._nameToUniform3[t] = [o, i, r] : (e[0] = o, e[1] = i, e[2] = r);
      }
    }
  }, {
    key: "setUniform3fv",
    value: function setUniform3fv(t, o) {
      var i = this._nameToUniform3[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform3fv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform3[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniform4f",
    value: function setUniform4f(t, o, i, r, e) {
      var _n2 = this._nameToUniform4[t];

      if (void 0 === _n2 || o !== _n2[0] || i !== _n2[1] || r !== _n2[2] || e !== _n2[3]) {
        this._context.useProgram(this);

        this._context.gl.uniform4f(this._getUniformLocation(t), o, i, r, e), void 0 === _n2 ? this._nameToUniform4[t] = [o, i, r, e] : (_n2[0] = o, _n2[1] = i, _n2[2] = r, _n2[3] = e);
      }
    }
  }, {
    key: "setUniform4fv",
    value: function setUniform4fv(t, o) {
      var i = this._nameToUniform4[t];

      if (s(i, o)) {
        this._context.useProgram(this);

        this._context.gl.uniform4fv(this._getUniformLocation(t), o), void 0 === i ? this._nameToUniform4[t] = Array.from(o) : f(o, i);
      }
    }
  }, {
    key: "setUniformMatrix3fv",
    value: function setUniformMatrix3fv(t, o) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var e = this._nameToUniformMatrix3[t];

      if (r ? e !== o : c(e, o)) {
        this._context.useProgram(this);

        this._context.gl.uniformMatrix3fv(this._getUniformLocation(t), i, o), void 0 === e ? this._nameToUniformMatrix3[t] = Array.from(o) : f(o, e);
      }
    }
  }, {
    key: "setUniformMatrix4fv",
    value: function setUniformMatrix4fv(t, o) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var r = this._nameToUniformMatrix4[t];

      if (_(r, o)) {
        this._context.useProgram(this);

        this._context.gl.uniformMatrix4fv(this._getUniformLocation(t), i, o), void 0 === r ? this._nameToUniformMatrix4[t] = Array.from(o) : f(o, r);
      }
    }
  }, {
    key: "assertCompatibleVertexAttributeLocations",
    value: function assertCompatibleVertexAttributeLocations(t) {
      t.locations !== this._locations && console.error("VertexAttributeLocations are incompatible");
    }
  }, {
    key: "stop",
    value: function stop() {}
  }]);

  return n;
}();

function s(t, i) {
  if (o(t) || t.length !== i.length) return !0;

  for (var _o = 0; _o < t.length; ++_o) {
    if (t[_o] !== i[_o]) return !0;
  }

  return !1;
}

function m(t, o, r) {
  var n = "webgl2" === t.webglVersion ? e(r, o) : r,
      s = t.gl,
      m = s.createShader(o);
  return s.shaderSource(m, n), s.compileShader(m), i() && !s.getShaderParameter(m, s.COMPILE_STATUS) && (console.error("Compile error in ".concat(35633 === o ? "vertex" : "fragment", " shader")), console.error(s.getShaderInfoLog(m)), console.error(a(n)), "webgl2" === t.webglVersion && (console.log("Shader source before transpilation:"), console.log(r))), m;
}

function a(t) {
  var o = 2;
  return t.replace(/\n/g, function () {
    return "\n" + h(o++) + ":";
  });
}

function h(t) {
  return t >= 1e3 ? t.toString() : ("  " + t).slice(-3);
}

function f(t, o) {
  for (var _i = 0; _i < t.length; ++_i) {
    o[_i] = t[_i];
  }
}

function c(t, i) {
  return !!o(t) || (9 !== t.length ? s(t, i) : 9 !== t.length || t[0] !== i[0] || t[1] !== i[1] || t[2] !== i[2] || t[3] !== i[3] || t[4] !== i[4] || t[5] !== i[5] || t[6] !== i[6] || t[7] !== i[7] || t[8] !== i[8]);
}

function _(t, i) {
  return !!o(t) || (16 !== t.length ? s(t, i) : 16 !== t.length || t[0] !== i[0] || t[1] !== i[1] || t[2] !== i[2] || t[3] !== i[3] || t[4] !== i[4] || t[5] !== i[5] || t[6] !== i[6] || t[7] !== i[7] || t[8] !== i[8] || t[9] !== i[9] || t[10] !== i[10] || t[11] !== i[11] || t[12] !== i[12] || t[13] !== i[13] || t[14] !== i[14] || t[15] !== i[15]);
}

export { n as Program };